import React from 'react';

import { usePathParam } from 'react-resource-router';

import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import { ContextualAnalyticsData, SCREEN } from '@atlassian/analytics-bridge';
import { useResource } from '@atlassian/eoc-rrr-helpers';

import { type RoutingRuleProps } from '../common/types';
import { routingRulesResource } from '../services/resources';

import RoutingRules from './routing-rules';

export default function RoutingRulesPage({ onRoutingRuleModalOpen, schedules }: RoutingRuleProps) {
	const [teamId] = usePathParam('teamId');
	const { loading, error } = useResource(routingRulesResource);

	if (loading) {
		return <UFOLoadHold name="eoc-routing-rules-loading" />;
	}

	if (error) {
		return null;
	}

	return (
		<ContextualAnalyticsData
			tags={['on-call', 'routing-rules']}
			sourceType={SCREEN}
			sourceName="OnCall"
			objectId={teamId}
			objectType="routingRule"
		>
			<RoutingRules schedules={schedules} onRoutingRuleModalOpen={onRoutingRuleModalOpen} />
		</ContextualAnalyticsData>
	);
}
